module.exports = __webpack_public_path__ + "img/kyc1-1.3dffb1d1.png";